import axios from 'axios';
import config from '@/config';
import store from './../index';
import * as types from './mutation-types';

const clientEndpoint = `${config.API_URL}/Clients`;
const monitoringEndpoint = `${config.API_URL}/Monitorings`;
const portfolioEndpoint = `${config.API_URL}/Portfolios`;
// const adminEndpoint = `${config.API_URL}/admin`
const packagesEndpoint = `${config.API_URL}/Packages`;
const historyImportEndpoint = `${config.API_URL}/imports`;
const BillingImportEndpoint = `${config.API_URL}/Billing`;

export const exportPortfolio = () =>
  new Promise((resolve, reject) =>
    axios
      .get(`${portfolioEndpoint}/export`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response))
      .catch(reject),
  );

export const addUser = (_, { id, firstName, lastName, email, isMainUser, address }) =>
  new Promise((resolve, reject) =>
    axios
      .post(
        `${clientEndpoint}/${id}/users`,
        { firstName, lastName, email, isMainUser, billing_address: address },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(err => {
        reject(err);
      }),
  );

export const getBillingByDate = (_, { date }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${BillingImportEndpoint}?date=${date.getUTCFullYear()}/${date.getUTCMonth() + 1}/${date.getUTCDate()}`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const getUsers = (_, { id }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${clientEndpoint}/${id}`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const editClient = (_, { id, name, code, address, isActivated, taxeName, alertFrequency, defaultPackageLevelPublicId, mainUserShouldReceiveAlerts }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(
        `${clientEndpoint}/${id}`,
        {
          name,
          code,
          AddressBilling: address,
          isActivated,
          taxeName,
          alertFrequency,
          defaultPackageLevelPublicId,
          mainUserShouldReceiveAlerts,
        },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const getClients = (_, search) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${clientEndpoint}?Search=${search}`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const addCompany = (
  _,
  { siren, id, address, taxeName, confidentialAccess, effectiveBeneficiariesAccess, alertFrequency, mainUserShouldReceiveAlerts },
) =>
  new Promise((resolve, reject) =>
    axios
      .post(
        `${clientEndpoint}/`,
        {
          siren,
          code: id,
          AddressBilling: address,
          taxeName,
          confidentialAccess,
          effectiveBeneficiariesAccess,
          alertFrequency,
          mainUserShouldReceiveAlerts,
        },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const editCompany = ({ dispatch }, { id, name, confidentialAccess, effectiveBeneficiariesAccess, taxeName, alertFrequency }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(
        `${clientEndpoint}/${id}`,
        { name, confidentialAccess, effectiveBeneficiariesAccess, taxeName, alertFrequency },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => {
        dispatch('getUser');
        resolve(response.data);
      })
      .catch(reject),
  );

export const getPackagesLevel = (_, data) =>
  new Promise((resolve, reject) => {
    if (!data || (!data.pageSize && !data.pageNumber)) {
      return axios
        .get(`${monitoringEndpoint}/packagelevel?pageNumber=0&pageSize=999999`, {
          headers: { Authorization: `Token ${store.getters.apikey}` },
        })
        .then(response => resolve(response.data))
        .catch(reject);
    } else {
      return axios
        .get(
          `${monitoringEndpoint}/packagelevel?${data.pageSize ? `pageSize=${data.pageSize}` : ``}${data.pageNumber ? `&pageNumber=${data.pageNumber}` : ``}`,
          { headers: { Authorization: `Token ${store.getters.apikey}` } },
        )
        .then(response => resolve(response.data))
        .catch(reject);
    }
  });

export const uploadImportCompanyFile = (_, { data }) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${monitoringEndpoint}/csvImport`, data, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const setImageCompany = (_, data) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${clientEndpoint}/image`, data, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const addPackage = (_, { packagePublicId, level, label }) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${monitoringEndpoint}/packagelevel`, { packagePublicId, level, label }, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const editPackage = (_, { id, packagePublicId, level, label, isEnabled }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(
        `${monitoringEndpoint}/packagelevel/${id}`,
        { packagePublicId, level: Number(level), label, isEnabled },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const getPackages = () =>
  new Promise((resolve, reject) =>
    axios
      .get(`${packagesEndpoint}`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const postPackage = (_, { name, packageCombinaisonValue, clientPublicId, pricePm, pricePp, code }) =>
  new Promise((resolve, reject) =>
    axios
      .post(
        `${packagesEndpoint}`,
        { name, packageCombinaisonValue, clientPublicId, pricePm, pricePp, code },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const patchPackage = (_, { id, name, packageCombinaisonValue, clientPublicId, pricePm, pricePp, code, isEnabled }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(
        `${packagesEndpoint}/${id}`,
        { name, packageCombinaisonValue, clientPublicId, pricePm, pricePp, code, isEnabled },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const startMonitoring = (_, { siren, internalRef, publicManagerId, packageLevelPublicId }) =>
  new Promise((resolve, reject) =>
    axios
      .post(
        `${monitoringEndpoint}/`,
        { siren, internalRef, managerPublicId: publicManagerId, packageLevelPublicId },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const patchMonitoring = (_, { siren, internalRef, publicManagerId, packageLevelPublicId }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(
        `${portfolioEndpoint}/${siren}`,
        { internalRef, managerPublicId: publicManagerId, packageLevelPublicId },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const getPortfolioBySiren = (_, { siren }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${portfolioEndpoint}/${siren}`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => resolve(response.data))
      .catch(err => {
        if (err.response.status === 404) resolve(err.response);
        reject(err);
      }),
  );

export const getPortfolioExport = (_, { siren }) =>
  new Promise((resolve, reject) =>
    axios({
      url: `${portfolioEndpoint}/${siren}/export`,
      method: 'GET',
      responseType: 'blob',
      headers: { Authorization: `Token ${store.getters.apikey}` },
    })
      .then(response => resolve(response))
      .catch(err => {
        reject(err);
      }),
  );

export const getHistoryImports = (_, { pageNumber = 0, pageSize = 0, search, isManual, managerPublicId }) =>
  new Promise((resolve, reject) =>
    axios
      .get(
        `${historyImportEndpoint}?${pageSize ? `pageSize=${pageSize}` : ``}${
          pageNumber ? `&pageNumber=${pageNumber}` : ``
        }${search ? `&Search=${search}` : ``}${managerPublicId ? `&ManagerPublicId=${managerPublicId}` : ``}${isManual ? `&isManual=${isManual}` : ``}`,
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const getHistoryImportById = (_, { pageNumber = 0, pageSize = 0, id, search, action }) =>
  new Promise((resolve, reject) =>
    axios
      .get(
        `${historyImportEndpoint}/${id}?${pageSize ? `pageSize=${pageSize}` : ``}${search ? `&search=${search}` : ``}${
          action ? `&actionType=${action}` : ``
        }${pageNumber ? `&pageNumber=${pageNumber}` : ``}`,
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );
export const getPortfolio = (_, { pageNumber = 0, pageSize = 0, manager, monitoring, search, startRenewalDate, endRenewalDate }) =>
  new Promise((resolve, reject) =>
    axios
      .get(
        `${portfolioEndpoint}?${pageSize ? `pageSize=${pageSize}` : ``}${
          pageNumber ? `&pageNumber=${pageNumber}` : ``
        }${manager ? `&ManagerPublicId=${manager}` : ``}${monitoring ? `&PackageLevelPublicId=${monitoring}` : ``}${search ? `&Search=${search}` : ``}${
          startRenewalDate ? `&StartRenewalDate=${startRenewalDate}` : ``
        }${endRenewalDate ? `&EndRenewalDate=${endRenewalDate}` : ``}`,
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => resolve(response.data))
      .catch(reject),
  );

export const setManagerFilter = ({ commit }, { id }) => {
  commit(types.SET_MANAGER_FILTER, id);
};

export const getTaxesLookup = () =>
  new Promise((resolve, reject) =>
    axios
      .get(`${config.API_URL}/lookups/taxes`)
      .then(res => resolve(res.data))
      .catch(reject),
  );

export const getClientsInsights = async ({ getters }, { pageSize, pageNumber, search, sortBy, accountWithActivities }) => {
  const result = await axios.get(
    `${config.API_URL}/Clients/insights?pageSize=${pageSize}&pageNumber=${pageNumber}&Search=${search}&SortBy=${sortBy}&accountWithActivities=${accountWithActivities}`,
    { headers: { Authorization: `Token ${getters.apikey}` } },
  );
  return result.data;
};

export const getInsights = async ({ getters }) => {
  const result = await axios.get(`${config.API_URL}/Insights`, {
    headers: { Authorization: `Token ${getters.apikey}` },
  });
  return result.data;
};

export const getMonitoringInsights = async ({ getters }) => {
  const result = await axios.get(`${config.API_URL}/Insights/monitoring`, {
    headers: { Authorization: `Token ${getters.apikey}` },
  });
  return result.data;
};

export const getPackagesInsights = async ({ getters }) => {
  const result = await axios.get(`${config.API_URL}/Insights/packages`, {
    headers: { Authorization: `Token ${getters.apikey}` },
  });
  return result.data;
};

export const exportInsights = async ({ getters }, { search, accountWithActivities }) =>
  await axios({
    url: `${config.API_URL}/Clients/insights/export?Search=${search}&accountWithActivities=${accountWithActivities}`,
    method: 'GET',
    responseType: 'blob',
    headers: { Authorization: `Token ${getters.apikey}` },
  });

export const getClientInsight = async ({ getters }, id) => {
  const result = await axios.get(`${config.API_URL}/Clients/${id}/insights`, {
    headers: { Authorization: `Token ${getters.apikey}` },
  });
  return result.data;
};

export const getClientPieChartInsight = async ({ getters }, id) => {
  const result = await axios.get(`${config.API_URL}/Clients/${id}/insights/packages`, {
    headers: { Authorization: `Token ${getters.apikey}` },
  });
  return result.data;
};

export const sendAccountConfirmation = async ({ getters }, { clientId, userId }) =>
  axios({
    url: `${config.API_URL}/Clients/${clientId}/users/${userId}/invitation`,
    method: 'PATCH',
    headers: { Authorization: `Token ${getters.apikey}` },
  });

export const deleteUser = async ({ getters }, { clientId, userId }) => {
  await axios.delete(`${config.API_URL}/Clients/${clientId}/users/${userId}`, {
    headers: { Authorization: `Token ${getters.apikey}` },
  });
};
